import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { PreferencesService } from '../../preferences/preferences.service';
import { FormsVM, ModalIncidentRequired, ModalToggleForm } from '../perform-induction/perform-induction';
import { SafetyInductionService } from '../services/safety-induction.service';
import { DialogAddFormCatrgoryComponent } from './Components/dialog-add-form-catrgory/dialog-add-form-catrgory.component';
import { DialogAddFormComponent } from './Components/dialog-add-form/dialog-add-form.component';
import { DialogEditDetailsComponent } from './Components/dialog-edit-details/dialog-edit-details.component';
export class DialogResponse{
  type:number;
  stateId:number;
  CatId:number
}
@Component({
  selector: 'app-config-setup-forms',
  templateUrl: './config-setup-forms.component.html',
  styleUrls: ['./config-setup-forms.component.css']
})
export class ConfigSetupFormsComponent implements OnInit {

  constructor(private _router: Router,
    private _appService: AppService,
    private _inductionService: SafetyInductionService,
    public dialog: MatDialog,
    private readonly _pref: PreferencesService,) { }

  DataForFormSetup: FormsVM;
  loading: boolean = false;

  ngOnInit() {
    this._appService.setPageTitle('Setup Forms');
    //this._appService.setPageSubTitle('');

    this._GETSetupForms();

  }

  _GETSetupForms() {
    this.loading = true
    this._inductionService.GETSetupForms().subscribe(res => {
      console.log("GETSetupForms", res)
      if (res.m_Item1) {

        let arr = res.m_Item2
        arr.Categories.map(c => {
          let _forms = arr.Forms.filter(f => f.FormCategoryID == c.ID)
          c.Forms = _forms
        })

        if(arr.Categories && arr.Categories.length>0){

          arr.Categories.map(cat=>{
            let cpy = Object.assign({},cat)

            cat.Forms = cpy.Forms.sort((a, b) => a.Name.localeCompare(b.Name))
          })

          this.DataForFormSetup = arr

        }

        

        console.log("arr", arr)
      }


      this.loading = false
    })
  }

  ClickEditCatName(cat) {
    const dialogRef = this.dialog.open(DialogEditDetailsComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        EditForm: false,
        FormCategory:cat
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this._GETSetupForms();
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }


//Add new form category
  ClickAddCatName() {
    const dialogRef = this.dialog.open(DialogAddFormCatrgoryComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
       // EditForm: false,
      //  FormCategory:cat
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this._GETSetupForms();
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }



  ClickEditFormName(form) {
    if(form.IsDigital){
      
     // this._router.navigate(['/createsafetydigitalform',form.ID ]);
     this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/createsafetydigitalform',form.ID ]);
      }else{             
        window.open('/createsafetydigitalform/' + form.ID, '_blank');
       
      }
  });

    }else{
    const dialogRef = this.dialog.open(DialogEditDetailsComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        EditForm: true,
        Form:form,
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this._GETSetupForms();
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }
  }

  CkickDeleteForm(form) {

    let params = new ModalToggleForm();
    params.formID = form.ID;
    params.active = false;
    this._inductionService.ToggleForm(params).subscribe(res => {
      console.log("ToggleIncidentNoRequired res", res)
      this._GETSetupForms();
    })
  }

  onClickAddForm(cat) {
    console.log("cat", cat)
    const dialogRef = this.dialog.open(DialogAddFormComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        FormCategory:cat,
        States:this.DataForFormSetup.States
      }

    });

    dialogRef.afterClosed().subscribe((result:DialogResponse) => {
      if (result.type == 1) {
        this._GETSetupForms();
      } else if (result.type == 2) {
        //this._router.navigate(['/createsafetydigitalform',result.CatId ]);
        this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
          if(res=="True"){
            this._router.navigate(['/createsafetydigitalform',result.CatId ]);
          }else{             
            window.open('/createsafetydigitalform/' + result.CatId, '_blank');     
          }
      });
    
        
      }
    });
  }

  changeCheckboxIncidentReport(_category, check) {
    console.log("_category, check", _category, check)

    let params = new ModalToggleForm();
    params.formID = _category.ID;
    params.active = check;
    this._inductionService.ToggleIncidentNoRequired(params).subscribe(res => {
      console.log("ToggleIncidentNoRequired res", res)
    })
  }

}
